export const APP_NAME = 'Shesha Boilerplate';

export const ACCESS_TOKEN_NAME = 'xDFcxiooPQxazdndDsdRSerWQPlincytLDCarcxVxv';

/** Application header: Shesha's header exposed on the LandBank.Crm module, carrying LandBank's customisations. */
export const HEADER_FORM_ID = { module: 'LandBank.Crm', name: 'header' };
